class Wait_For {
    static path = 'logic/wait-for';

    constructor(mutator) {
        this.bgcolor = '#70d3ef';
        this.title = 'Wait For...';
        this.desc = 'Wait for a certain amount of time before continuing.';
        this.properties = {unit: 'Days'}

        this.addInput("Pass-through data", "");
        this.addInput("Wait For (X)", "");
        this.addOutput("data", "nooutput");
        this.addWidget("combo", "", '', {property: "unit", values: ['Minutes', 'Hours', 'Days', 'Months', 'Years']});
    }

    getTitle() {
        if(this.properties.unit) return "Wait For X " + this.properties.unit;
        return this.title;
    }

    onConnectionsChange(type, slot) {
        if(type === 1 && slot === 0) { //LiteGraph.INPUT
            let parent_node = this.getParentNode(0);
            if (!parent_node) {
                this.outputs[0].type = 'nooutput';
                this.disconnectOutput(0);
                return;
            }

            if(this.outputs[0].type !== parent_node.outputs[0].type)
                this.disconnectOutput(0);
            this.outputs[0].type = parent_node.outputs[0].type;
        }
    }

}

module.exports = Wait_For
